import * as React from "react"
import {Dialog, DialogContent, Box, Typography, CircularProgress} from "@mui/material"

import {showCreatingBatchModal} from "../@signals"


export default function CreatingBatchModal() {
	return (
		<Dialog
			open={showCreatingBatchModal.value}
			disableEscapeKeyDown
			maxWidth="sm"
			fullWidth
			PaperProps={{
				sx: {
					borderRadius: 2,
					p: 2
				}
			}}
		>
			<DialogContent>
				<Box
					sx={{
						display: 'flex',
						flexDirection: 'column',
						alignItems: 'center',
						gap: 3,
						py: 4
					}}
				>
					<CircularProgress size={60} thickness={4} />
					
					<Box sx={{ textAlign: 'center' }}>
						<Typography variant="h6" gutterBottom>
							Creating Batch...
						</Typography>
						<Typography variant="body2" color="text.secondary" sx={{ mt: 2 }}>
							This process may take from a few seconds to several minutes,
						</Typography>
						<Typography variant="body2" color="text.secondary">
							depending on the batch size.
						</Typography>
						<Typography variant="body2" color="text.secondary" sx={{ mt: 2, fontWeight: 500 }}>
							Please do not close this window.
						</Typography>
					</Box>
				</Box>
			</DialogContent>
		</Dialog>
	)
}
